import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e96eb3ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag is-success ml-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-star mr-1" }, null, -1))

import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import BulmaTooltip from "@/components/common/BulmaTooltip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TryThisPill',
  props: {
  label: {
    type: String,
    required: true
  },
  localStorageProperty: {
    type: String,
    required: true
  },
  toolTipWidth: {
    type: String,
    required: true
  },
  toolTipPosition: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props

const forceVisible = ref(false)

onMounted(() => {
  const localStorageProp = localStorage.getItem(props.localStorageProperty)
  forceVisible.value = localStorageProp == null || localStorageProp === 'false'
  if (forceVisible.value) {
    window.addEventListener('click', onGlobalClick, true)
    localStorage.setItem(props.localStorageProperty, 'true')
  }
})

const onGlobalClick = () => {
  //clicking ANYWHERE in the UI needs to set forceVisible to false
  forceVisible.value = false
}

watch(forceVisible, (value, oldValue) => {
  if (typeof window === 'undefined') return
  if (value === oldValue) return
  if (!value) {
    window.removeEventListener('click', onGlobalClick, true)
  }
})

onBeforeUnmount(() => {
  if (typeof window === 'undefined') return
  window.removeEventListener('click', onGlobalClick, true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BulmaTooltip, {
    "wrap-text": "",
    type: "is-light is-primary",
    label: __props.label,
    "force-visible": forceVisible.value,
    "fixed-width": __props.toolTipWidth,
    position: __props.toolTipPosition
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('tryThis')), 1)
      ])
    ], undefined, true),
    _: 1
  }, 8, ["label", "force-visible", "fixed-width", "position"]))
}
}

})